/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateOrdercartFromCalculationitemsDto } from '../models/work-create-ordercart-from-calculationitems-dto';
import { WorkOrdercart } from '../models/work-ordercart';
import { WorkPlaceOrderResultDto } from '../models/work-place-order-result-dto';
import { WorkPlaceOrdercartDto } from '../models/work-place-ordercart-dto';
import { WorkUpdateOrdercartDto } from '../models/work-update-ordercart-dto';

@Injectable({ providedIn: 'root' })
export class WorkOrdercartsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ordercartsV2ControllerFindAll()` */
  static readonly OrdercartsV2ControllerFindAllPath = '/v2/ordercarts';

  /**
   * Required permissions: orders:read, orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordercartsV2ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordercartsV2ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkOrdercart>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkOrdercartsV2Service.OrdercartsV2ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkOrdercart>>;
      })
    );
  }

  /**
   * Required permissions: orders:read, orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordercartsV2ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordercartsV2ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkOrdercart>> {
    return this.ordercartsV2ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkOrdercart>>): Array<WorkOrdercart> => r.body)
    );
  }

  /** Path part for operation `ordercartsV2ControllerFindOneById()` */
  static readonly OrdercartsV2ControllerFindOneByIdPath = '/v2/ordercarts/{id}';

  /**
   * Required permissions: orders:read, orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordercartsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordercartsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkOrdercart>> {
    const rb = new RequestBuilder(this.rootUrl, WorkOrdercartsV2Service.OrdercartsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrdercart>;
      })
    );
  }

  /**
   * Required permissions: orders:read, orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordercartsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordercartsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkOrdercart> {
    return this.ordercartsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkOrdercart>): WorkOrdercart => r.body)
    );
  }

  /** Path part for operation `ordercartsV2ControllerDelete()` */
  static readonly OrdercartsV2ControllerDeletePath = '/v2/ordercarts/{id}';

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordercartsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordercartsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkOrdercartsV2Service.OrdercartsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordercartsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordercartsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.ordercartsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `ordercartsV2ControllerUpdate()` */
  static readonly OrdercartsV2ControllerUpdatePath = '/v2/ordercarts/{id}';

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordercartsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordercartsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateOrdercartDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkOrdercart>> {
    const rb = new RequestBuilder(this.rootUrl, WorkOrdercartsV2Service.OrdercartsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrdercart>;
      })
    );
  }

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordercartsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordercartsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateOrdercartDto
    },
    context?: HttpContext
  ): Observable<WorkOrdercart> {
    return this.ordercartsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkOrdercart>): WorkOrdercart => r.body)
    );
  }

  /** Path part for operation `ordercartsV2ControllerCreateFromCalculationitems()` */
  static readonly OrdercartsV2ControllerCreateFromCalculationitemsPath = '/v2/ordercarts/from-calculationitems';

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordercartsV2ControllerCreateFromCalculationitems()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordercartsV2ControllerCreateFromCalculationitems$Response(
    params: {
      body: WorkCreateOrdercartFromCalculationitemsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkOrdercart>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkOrdercartsV2Service.OrdercartsV2ControllerCreateFromCalculationitemsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkOrdercart>>;
      })
    );
  }

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordercartsV2ControllerCreateFromCalculationitems$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordercartsV2ControllerCreateFromCalculationitems(
    params: {
      body: WorkCreateOrdercartFromCalculationitemsDto
    },
    context?: HttpContext
  ): Observable<Array<WorkOrdercart>> {
    return this.ordercartsV2ControllerCreateFromCalculationitems$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkOrdercart>>): Array<WorkOrdercart> => r.body)
    );
  }

  /** Path part for operation `ordercartsV2ControllerRemoveItem()` */
  static readonly OrdercartsV2ControllerRemoveItemPath = '/v2/ordercarts/{id}/calculationitems/{calculationitemId}';

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordercartsV2ControllerRemoveItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordercartsV2ControllerRemoveItem$Response(
    params: {
      id: number;
      calculationitemId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkOrdercart>> {
    const rb = new RequestBuilder(this.rootUrl, WorkOrdercartsV2Service.OrdercartsV2ControllerRemoveItemPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('calculationitemId', params.calculationitemId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrdercart>;
      })
    );
  }

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordercartsV2ControllerRemoveItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordercartsV2ControllerRemoveItem(
    params: {
      id: number;
      calculationitemId: number;
    },
    context?: HttpContext
  ): Observable<WorkOrdercart> {
    return this.ordercartsV2ControllerRemoveItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkOrdercart>): WorkOrdercart => r.body)
    );
  }

  /** Path part for operation `ordercartsV2ControllerPlaceOrder()` */
  static readonly OrdercartsV2ControllerPlaceOrderPath = '/v2/ordercarts/{id}/order';

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordercartsV2ControllerPlaceOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordercartsV2ControllerPlaceOrder$Response(
    params: {
      id: number;
      body: WorkPlaceOrdercartDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPlaceOrderResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkOrdercartsV2Service.OrdercartsV2ControllerPlaceOrderPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPlaceOrderResultDto>;
      })
    );
  }

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordercartsV2ControllerPlaceOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordercartsV2ControllerPlaceOrder(
    params: {
      id: number;
      body: WorkPlaceOrdercartDto
    },
    context?: HttpContext
  ): Observable<WorkPlaceOrderResultDto> {
    return this.ordercartsV2ControllerPlaceOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPlaceOrderResultDto>): WorkPlaceOrderResultDto => r.body)
    );
  }

}
